import React from 'react';

export const Card = ({ title, info, children, content, className = '' }) => (
  <div className={`card position-relative ${className}`}>
    <div className="card-header">
      <div className="card-title">{title}</div>
      <div className="heading-elements">{info}</div>
    </div>
    <div className="card-body">{children}</div>
    {content}
  </div>
);
